import { render, staticRenderFns } from "./PageDaysSkeleton.vue?vue&type=template&id=f987a996"
import script from "./PageDaysSkeleton.vue?vue&type=script&lang=js"
export * from "./PageDaysSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PageDaysSkeleton.vue?vue&type=style&index=0&id=f987a996&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports